import { Avatar, Button, Stack, Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { ConfirmationDialog } from "@/components/Dialog/ConfirmationDialog";

interface SaveSharedSegmentDialogProps {
  open: boolean;
  isSaving: boolean;
  onClose: () => void;
  onSaveAndUpdate: () => void;
  onSaveAsNew: () => void;
}

export const SaveSharedSegmentDialog: React.FC<
  SaveSharedSegmentDialogProps
> = ({ open, isSaving, onClose, onSaveAndUpdate, onSaveAsNew }) => (
  <ConfirmationDialog
    title="Shared Segment"
    open={open}
    actions={
      <Stack
        direction="row"
        spacing={1}
        width="100%"
        justifyContent="space-between"
        padding={2}
      >
        <Button
          color="secondary"
          variant="outlined"
          onClick={onClose}
          disabled={isSaving}
          data-testid="save-shared-segment-cancel-btn"
        >
          Cancel
        </Button>
        <Stack direction="row" spacing={1}>
          <Button
            color="secondary"
            variant="outlined"
            onClick={onSaveAsNew}
            disabled={isSaving}
            data-testid="save-shared-segment-as-new-btn"
          >
            Save as New Segment (no link)
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSaveAndUpdate}
            disabled={isSaving}
            data-testid="save-shared-segment-update-btn"
          >
            Save & Update Shared Link
          </Button>
        </Stack>
      </Stack>
    }
    onClose={onClose}
  >
    <Stack minWidth={500} alignItems="center" gap={2} padding={2}>
      <Avatar sx={{ bgcolor: "#c8e6c9", color: "black" }}>
        <LinkIcon />
      </Avatar>
      <Typography fontWeight={600} fontSize="20px" mb={1}>
        This segment has a shared link
      </Typography>
      <Typography>
        Saving applies the new filters and geography to the shared link right
        away. Market Sizing settings (spend categories, tier names) only change
        when you click Share and update the link.
      </Typography>
      <Typography>
        To keep the shared view as it is, save these filters as a new segment
        instead — it won't have a shared link.
      </Typography>
    </Stack>
  </ConfirmationDialog>
);
